import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SingleServiceModern from '../components/sections/SingleServiceModern';
import Banner4 from '../components/sections/Banner4';

const services = {
  'listing-optimization': {
    title: 'Amazon Listing Optimization',
    image: '/images/Amazon Listing Optimization.jpg',
    subtitle: 'Expand your brand\'s visibility and keep visitors hooked on your listing!',
    description: 'At TrioPerspective, we understand the Importance of every click. Your product listings are the key to building trust and driving sales on Amazon. Our optimization service makes sure your listings stand out and convert visitors into buyers. keep your eyes on the big picture, we will handle the little things. let us turn clicks into customers!',
    overviewTitle: 'Listing Optimization?',
    overview: 'Because first Impressions matter - Your listing is the first thing customers see – let\'s make sure it leaves a lasting impact. We optimize your product listings by improving titles, descriptions, main images, and A+ Content to make them more attractive. Our goal is to help you stand out and turn visitors into buyers.',
    optimization: 'Amazon Product Listing Optimization Process',
    optimizationDescription: 'We transform your listings into attention magnets by perfecting titles, crafting compelling descriptions, and choosing the best images. Every tweak is designed to boost visibility and turn clicks into loyal customers.',
    features: [
      {
        title: 'Market Research',
        description: 'We start by understanding your product and target audience. By analyzing bestselling product listings on Amazon and conducting thorough market research, we identify the ideal target audience. Additionally, we study your competitors to understand their strengths and weaknesses, allowing us to strategically position your listings for success.'
      },
      {
        title: 'Keyword Research',
        description: 'We conduct in-depth keyword research to identify high-search-volume and high-conversion keywords for your product. This ensures your listing is optimized to attract the right customers and improves search visibility.'
      },
      {
        title: 'Main Image Optimization',
        description: 'Your main image is the first impression of your product, so it\'s crucial to make it stand out. We focus on creating eye-catching, high-quality images that showcase your product\'s features, lifestyle use, and details. These images are used in both the main listing and A+ content to maximize engagement.'
      },
      {
        title: 'Product Bullet Points Creation',
        description: 'Effective bullet points are key to our Amazon listing optimization process. We highlight your product\'s best features and uses in a clear and concise manner, ensuring they are customer-focused and include convertible keywords. This approach improves your Amazon ranking and makes your listing more attractive to potential buyers.'
      },
      {
        title: 'Product Description Enhancement',
        description: 'A strong product description builds trust and creates a connection with customers. We craft detailed descriptions that highlight every aspect of your product, incorporating high-search-volume and convertible keywords. This not only enhances the listing\'s appeal but also helps in ranking better on Amazon.'
      },
      {
        title: 'Backend Search Terms Creation',
        description: 'Search terms in the backend are critical for increasing your product\'s visibility on Amazon. We focus on adding relevant keywords, alternative spellings, and generic terms that may not fit in the title or description but significantly improve search rankings. This ensures your product is discoverable for a broader range of customer searches.'
      },
      {
        title: 'Conversion Rate Optimization',
        description: 'We enhance your listing\'s ability to convert visitors into buyers by employing persuasive copywriting techniques, clear call-to-actions, and customer-centric messaging. Our goal is to create a seamless and compelling shopping experience.'
      },
      {
        title: 'Ongoing Monitoring and Optimization',
        description: 'Our work doesn\'t stop once the listing is live. We continuously monitor its performance and make data-driven adjustments to ensure it remains competitive and effective over time. This includes tweaking keywords, images, and descriptions based on customer feedback and market trends.'
      }
    ],
    results: 'The Magic of Optimization',
    resultsDescription: 'See how our optimization turns every small detail into a big opportunity. From boosting visibility to driving massive sales, our clients have watched their products on new heights, reflecting in millions of clicks and conversions. It\'s not just optimization—it\'s the magic that makes numbers grow.',
    benefits: [
      'Boost Visibility & Traffic',
      'Improve product Ranking',
      'Better Customer Understanding',
      'Drive More and More Sales'
    ],
    stat: [
      {
        value: '50%',
        label: 'Average increase in sales'
      },
      {
        value: '2X',
        label: 'Conversion Rate'
      },
      {
        value: '#12',
        label: 'Reach to Best Selling Product'
      },
      {
        value: '90%',
        label: 'Client Satisfaction'
      }
    ]
  },
  'ppc-management': {
    title: 'Amazon PPC Campaign Management',
    image: '/images/amazon ppc.jpg',
    subtitle: 'Convert Your Click into Sales Machine with Expert Optimization',
    description: 'At TrioPerspective, we know every ad click counts. A well-managed Amazon PPC campaign is your ticket to reaching the right audience and boosting sales. Our expert team crafts tailored strategies to ensure your amazon ads don\'t just get clicks—they drive results. Stay focused on your business goals, and let us maximize your ad spend for real returns. Maximize your advertising ROI with our data-driven PPC campaign management services.',
    overviewTitle: 'Ads Management Team?',
    overview: 'In the competitive Amazon marketplace, success is about more than just clicks—it\'s about results. Our PPC management service is designed to deliver maximum ROI by effectively targeting the right audience and positioning your brand ahead of competitors. We boost your brand\'s reach and guide shoppers through every stage of the journey—from awareness and consideration to conversion and loyalty—turn interest into sales, helping your business grow with smarter campaigns.',
    optimization: 'Our Process to Maximize ROI',
    optimizationDescription: 'Every brand and product have its own uniqueness and we treat them that way. By understanding each brand\'s perspective, we create and manage tailored PPC campaigns to drive sales and engagement.',
    features: [
      {
        title: 'Amazon PPC Account Audit',
        description: 'We start with a thorough audit of your existing PPC campaigns to identify areas for improvement. We review your account structure, campaign performance, and historical data to understand what\'s working and where adjustments are needed.'
      },
      {
        title: 'Campaign Strategy Development',
        description: 'We create a customized PPC strategy that aligns with your business goals, target audience, and product type. This ensures each ad type, like Sponsored Brands for brand visibility and Sponsored Display for reaching new customers, works together to drive the best results.'
      },
      {
        title: 'Keyword Research & Selection',
        description: 'We conduct in-depth keyword research to identify high-converting, relevant keywords with the best search volume. This research ensures your ads target the right audience at the right time.'
      },
      {
        title: 'Keyword Targeting & Segmentation',
        description: 'We target specific keywords based on search intent and customer behaviour, segmenting them into relevant ad groups for precise targeting. We apply keyword targeting strategies, such as broad, phrase, and exact match types, to ensure your ads reach the most relevant customers.'
      },
      {
        title: 'Bid Management & Optimization',
        description: 'We optimize bids across all campaign types, including Sponsored Brands and Sponsored Display, ensuring competitive bids are set for visibility. This allows for maximum return while keeping ACOS and ROI at a healthy level.'
      },
      {
        title: 'Campaign Structure Optimization',
        description: 'We reorganize your campaigns, ad groups, and targeting settings to improve efficiency and ensure better budget allocation. This includes separating automatic and manual campaigns for clearer performance tracking.'
      },
      {
        title: 'Improve Brand Awareness & Visibility',
        description: 'We focus on increasing your brand\'s visibility with strategies such as top-of-search placements and enhanced brand content, ensuring your products are prominently displayed to potential customers.'
      },
      {
        title: 'Conversion Rate Optimization',
        description: 'We monitor your campaigns\' conversion metrics and adjust to improve the percentage of visitors converting to buyers. This includes refining ad copy, optimizing product listings, and ensuring an efficient shopping experience.'
      },
      {
        title: 'Negative Keyword Optimization',
        description: 'We continuously review search term reports to identify and add irrelevant or non-converting keywords as negative keywords, preventing wasted ad spend and improving targeting precision.'
      },
      {
        title: 'A/B Testing & Ad Optimization',
        description: 'We perform A/B testing on Sponsored Products, Sponsored Brands, and Sponsored Display campaigns. For Sponsored Brands, this includes testing different creatives and headlines, while for Sponsored Display, we test targeting options and placements to find the most effective combinations.'
      },
      {
        title: 'Performance Monitoring & Adjustments',
        description: 'We constantly monitor key metrics such as CTR, CPC, ACOS, NTB Sales, VCPM, VTR and ROAS. Based on these insights, we make data-driven adjustments to optimize your campaigns.'
      },
      {
        title: 'Insights & Scaling',
        description: 'We provide detailed performance reports with key insights to track your campaigns\' success. Once optimized, we create a long-term scaling strategy, refining campaigns, expanding targeting, and adjusting budgets to maximize returns.'
      }
    ],
    results: 'PPC Excellence in Action',
    resultsDescription: 'Our tailored PPC campaigns have driven higher visibility, more clicks, and increased sales for our clients. With precise targeting and optimized bids, we turn ad spend into real results.',
    benefits: [
      'Build Brand Awareness',
      'Increased Product Visibility',
      'Maximize Return on Investment',
      'Stand Out from The Market Competition'
    ],
    stat: [
      {
        value: '75%',
        label: 'Sales Increased'
      },
      {
        value: '98%',
        label: 'Clients Satisfaction'
      },
      {
        value: '2X',
        label: 'Conversion Rate'
      },
      {
        value: '80%',
        label: 'Better Search Ranking'
      }
    ]
  },
  'keyword-seo': {
    title: 'Amazon Keyword SEO',
    image: '/images/Amazon SEO.jpg',
    subtitle: 'Boost Your Visibility and Drive Organic Traffic with Expert SEO Optimization',
    description: 'At TrioPerspective, we understand the power of the right keywords to get your products noticed. Our Amazon SEO services are designed to optimize your product listings, ensuring your brand appears at the top of search results and attracts the right customers. With proven strategies, we help you select the most relevant and high-converting keywords to boost your product\'s visibility and sales potential. Our team focuses on maximizing organic reach to help you build a stronger, sustainable presence on Amazon.',
    overviewTitle: 'Amazon Keywords SEO Services?',
    overview: 'In the ever-evolving Amazon marketplace, standing out organically is crucial. Our Amazon SEO services are built to enhance the discoverability of your products and improve your rankings on Amazon search results. We go beyond basic keyword research—we focus on comprehensive SEO strategies that help customers find your products more easily, increasing organic traffic and driving long-term growth. With our expert optimization, we ensure that your listings remain competitive and attractive to both Amazon\'s algorithm and shoppers.',
    optimization: 'Our Process to Rank Your Products Higher',
    optimizationDescription: 'We take a personalized approach to SEO by understanding the specifics of your brand and its products. Here\'s how we work to ensure your products rank higher and get more clicks.',
    features: [
      {
        title: 'In-Depth Keyword Research',
        description: 'We conduct comprehensive research to identify high-conversion and relevant keywords for your products. This includes backend search terms, keywords used in A+ content (crawlable keywords), and keywords for PPC targeting, ensuring your products reach the right audience.'
      },
      {
        title: 'Strategic Keyword Integration',
        description: 'We integrate these targeted keywords naturally into your product titles, bullet points, descriptions, and backend search terms. The goal is to balance keyword density and readability, ensuring your content is optimized for both Amazon\'s algorithm and your shoppers.'
      },
      {
        title: 'A+ Content Optimization',
        description: 'We enhance your A+ content with crawlable keywords to improve visibility and customer engagement. This includes adding relevant keywords that are also optimized for Amazon\'s algorithm, driving more organic traffic to your listings.'
      },
      {
        title: 'Conversion Rate Optimization (CRO)',
        description: 'We focus on boosting your product\'s conversion rate by optimizing images, reviews, and A+ content. With the right combination of visual appeal, customer feedback, and effective keywords, we aim to increase conversions and elevate your product\'s ranking.'
      },
      {
        title: 'PPC Campaign Optimization',
        description: 'We incorporate keyword strategies into your PPC targeting, ensuring your ads reach the right customers. By using high-performing keywords in your campaigns, we aim to drive targeted traffic and increase the likelihood of conversion.'
      },
      {
        title: 'SEO Analytics & Reporting',
        description: 'Amazon\'s algorithm is constantly changing, so we monitor your listings\' performance and provide regular data-driven reports on rankings, organic traffic, and sales. This transparency helps you track progress and make informed decisions.'
      }
    ],
    results: 'Keyword SEO Excellence in Action',
    resultsDescription: 'Our expertly crafted Amazon Keyword SEO strategies have significantly boosted product visibility, driven higher organic traffic, and improved sales rankings for our clients. Through in-depth keyword research and optimization, we convert search volume into impactful results.',
    benefits: [
      'Enhance Product Discoverability',
      'Boost Organic Traffic',
      'Maximize Search Engine Visibility',
      'Higher Conversion Rate'
    ],
    stat: [
      {
        value: '75%',
        label: 'Sales Increased'
      },
      {
        value: '98%',
        label: 'Clients Satisfaction'
      },
      {
        value: '2X',
        label: 'Conversion Rate'
      },
      {
        value: '80%',
        label: 'Better Search Ranking'
      }
    ]
  },
  'product-research': {
    title: 'Amazon Product Research Services',
    image: '/images/Amazon Product Research Services.jpg',
    subtitle: 'Unlock Profitable Product Opportunities with Expert Research',
    description: 'At TrioPerspective, we understand that finding the right products to sell on Amazon is the key to success. Our expert team dives deep into market trends, competition analysis, and consumer behaviour to identify profitable product opportunities for your business. Whether you\'re launching a new product or optimizing your existing offerings, our Amazon product research services are designed to give you the insights needed to make smarter business decisions and drive sustainable growth.',
    overviewTitle: 'Product Research Services?',
    overview: 'The Amazon marketplace is dynamic, and success depends on identifying the right products at the right time. Our product research service helps you discover high-demand, low-competition products that can generate solid profits. With in-depth analysis and strategic insights, we guide you to select the best products that align with your business goals and market trends. Stop guessing and start making data-driven decisions with our research-driven approach.',
    optimization: 'Our Process to Identify Profitable Products',
    optimizationDescription: 'Every product opportunity is unique, and we treat each one with a tailored approach. By analysing key metrics like sales volume, competition, price points, and customer reviews, we uncover profitable products that fit your brand and market strategy.',
    features: [
      {
        title: 'Market Analysis',
        description: 'We analyse market trends, examine competitors, and uncover emerging opportunities. This helps us identify profitable niches by understanding shifts in customer preferences and demands.'
      },
      {
        title: 'Demand Assessment',
        description: 'We evaluate the demand for products by assessing search volume, customer interest, and seasonal trends. This step ensures that the products we select align with market needs, giving them the best chance for success.'
      },
      {
        title: 'Competition Analysis',
        description: 'Our team studies competitors\' strategies, reviews, and pricing to identify your product\'s competitive advantage. We compare key factors like pricing, product features, and customer feedback to ensure you stand out.'
      },
      {
        title: 'Profitability Calculation',
        description: 'We calculate potential profit margins based on product costs, selling prices, and Amazon fees. This step ensures that your business can generate a solid ROI, helping you make informed decisions for long-term profitability.'
      }
    ],
    results: 'Launch Your Success with Confidence',
    resultsDescription: 'With our expert product research, your launches are set for success. By analyzing trends, competition, and customer needs, we help you introduce products that deliver real results.',
    benefits: [
      'Quick sales growth after launch',
      'Better visibility in a competitive market',
      'Stronger profits with the right pricing',
      'Happy customers who keep coming back'
    ],
    stat: [
      {
        value: '75%',
        label: 'Sales Increased'
      },
      {
        value: '98%',
        label: 'Clients Satisfaction'
      },
      {
        value: '2X',
        label: 'Conversion Rate'
      },
      {
        value: '80%',
        label: 'Better Search Ranking'
      }
    ]
  },
  'account-management': {
    title: 'Amazon Account Management Services',
    image: '/images/Amazon Account Management Services.jpg',
    subtitle: 'Unlock the Full Potential of Your Amazon Business with Expert Account Management',
    description: 'At TrioPerspective, we understand that managing an Amazon account is more than just listing products and monitoring sales. It\'s about building a strategic approach that aligns with your business goals. Our expert team provides end-to-end account management services, allowing you to focus on what matters most—growing your business. From optimizing your listings to handling customer feedback, we take care of the details that help your business thrive on Amazon.',
    overviewTitle: 'Full Account Management Service?',
    overview: 'In the fast-paced world of Amazon, it\'s not enough to just have your products listed. To stay ahead, you need a proactive approach to account management that maximizes visibility, sales, and customer satisfaction. Our comprehensive service covers all aspects of Amazon Seller Central, ensuring your account runs smoothly while driving long-term success. From improving listings to managing orders and enhancing your overall strategy, we\'re here to take your Amazon business to the next level.',
    optimization: 'Our Process to Supercharge Your Account',
    optimizationDescription: 'We take a personalized approach to each brand we work with, tailoring our strategy to match your unique needs. Here\'s how we handle Full Amazon Account Management',
    features: [
      {
        title: 'Product Research on Amazon',
        description: 'We conduct in-depth product research to identify profitable niches, analyse demand, and assess competition. This helps us choose the best products to sell, ensuring you tap into high-demand markets with minimal competition.'
      },
      {
        title: 'Keyword Research',
        description: 'We perform comprehensive keyword research to ensure your product listings are optimized for relevant, high-volume search terms. This increases visibility and drives targeted traffic to your listings, improving your chances of making sales.'
      },
      {
        title: 'Market Research & Analysis',
        description: 'We analyse market trends, customer behaviour, and competitors to uncover opportunities and ensure your product offerings are in line with current market demands. This strategic insight helps in identifying emerging trends and profitable niches.'
      },
      {
        title: 'SEO-Friendly Content Creation',
        description: 'Our team creates SEO-optimized content for your product listings, ensuring they rank higher on Amazon. We focus on crafting compelling titles, bullet points, descriptions and backed search terms that attract customers and drive conversions.'
      },
      {
        title: 'Product Listing Optimization',
        description: 'We enhance your product listings to ensure they\'re fully optimized for Amazon\'s search algorithm (A9). Our expert team focuses on making listings keyword-rich, detailed, and persuasive to convert browsers into buyers.'
      },
      {
        title: 'Amazon Graphics',
        description: 'Our design team creates high-quality images and Enhanced Brand Content (EBC) to showcase your products in the best light. These visuals help increase customer trust and drive higher conversion rates.'
      },
      {
        title: 'PPC & Ads Management',
        description: 'We manage your Amazon PPC campaigns to maximize visibility and sales. Our team monitors and optimizes ad campaigns to ensure you get the best return on investment while staying within budget.'
      },
      {
        title: 'Inventory Management',
        description: 'We help you maintain optimal inventory levels by monitoring sales patterns and demand fluctuations. This proactive approach prevents stockouts and overstocking, ensuring you never miss out on sales opportunities.'
      },
      {
        title: 'Buy Box Management',
        description: 'We monitor and adjust your pricing strategy to help you secure and maintain the Buy Box. Our team keeps an eye on competitors and adjusts your prices strategically to ensure consistent Buy Box ownership.'
      },
      {
        title: 'Analytics & Reporting',
        description: 'We provide detailed reports and insights into your account\'s performance. We track key metrics like sales, traffic, and conversions to evaluate what\'s working and identify areas for improvement.'
      },
      {
        title: 'Competitive Analysis & Strategy Planning',
        description: 'We continuously monitor your competition to understand their strategies, strengths, and weaknesses. Based on this data, we adjust your approach to help you stay ahead of the competition and maximize your sales potential.'
      },
      {
        title: 'Troubleshooting & Account Health Monitoring',
        description: 'We proactively monitor your Amazon account health, identifying potential issues and resolving them quickly. Our team ensures that your account stays in good standing with Amazon\'s policies and guidelines.'
      }
    ],
    results: 'Turning Goals into Growth',
    resultsDescription: 'We take care of every part of your Amazon business with skill and experience. Using smart strategies and data, we make sure your account runs smoothly, helping your brand grow easily and successfully.',
    benefits: [
      'Improve Conversion Rates',
      'Stronger Brand Presence',
      'Ongoing Performance Monitoring',
      'Healthy Account Health'
    ],
    stat: [
      {
        value: '75%',
        label: 'Sales Increased'
      },
      {
        value: '98%',
        label: 'Clients Satisfaction'
      },
      {
        value: '2X',
        label: 'Conversion Rate'
      },
      {
        value: '80%',
        label: 'Better Search Ranking'
      }
    ]
  },
  'troubleshooting': {
    title: 'Amazon Troubleshooting',
    image: '/images/Amazon Troubleshooting.jpg',
    subtitle: 'Solve Your Amazon Problems with Expert Support',
    description: 'At TrioPerspective, we understand that navigating Amazon\'s complex platform can be challenging. Whether it\'s an issue with your listings, account health, or performance metrics, we\'re here to help. Our Amazon Troubleshooting Service is designed to quickly identify and resolve any roadblocks, so your business runs smoothly. With our expert team, you can get back to focusing on growth while we handle the technicalities. We fix your Amazon issues, so you don\'t have to.',
    overviewTitle: 'Troubleshooting Experts?',
    overview: 'Amazon\'s platform can be overwhelming, and even small issues can snowball into bigger problems if not addressed quickly. Our troubleshooting service ensures that your account runs efficiently, keeping it in top shape for business success. From listing errors to account suspensions, we\'ve seen it all and know how to fix it fast. By identifying root causes and implementing effective solutions, we make sure your account stays in optimal condition.',
    optimization: 'Our Process to Resolve Your Amazon Issues',
    optimizationDescription: 'Every issue on Amazon is unique, and we take a personalized approach to fix them. Here\'s how we handle each step of the troubleshooting process.',
    features: [
      {
        title: 'Initial Assessment & Diagnosis',
        description: 'We begin by thoroughly reviewing your account or listing issues. Whether it\'s an error with your product listings, account health notifications, or Amazon\'s seller policies, we perform a complete diagnostic check.'
      },
      {
        title: 'Problem Identification',
        description: 'After the assessment, we pinpoint the root causes of the issues. It could be anything from listing violations, account suspensions, missing inventory, or performance issues. No problem is too small or too complex for our team.'
      },
      {
        title: 'Resolution Strategy',
        description: 'Once the problem is identified, we devise a strategy to resolve it efficiently. Our team drafts and submits appeals, works with Amazon\'s support teams, and fixes any technical glitches to ensure smooth operations.'
      },
      {
        title: 'Prevention & Future Monitoring',
        description: 'After resolving the issues, we put systems in place to prevent future occurrences. We continuously monitor your account, ensuring it stays in top shape, helping you avoid common pitfalls and keeping your business running smoothly.'
      }
    ],
    results: 'Solutions That Keep Your Amazon Business Running Smoothly',
    resultsDescription: 'We solve tricky problems that can slow down your sales. By combining expertise with a proactive approach, we address issues and solve, ensuring your store operates seamlessly and efficiently.',
    benefits: [
      'Optimize Account Health',
      'Recover Lost Inventory',
      'No More Frustration',
      'Resolve Account Suspensions'
    ],
    stat: [
      {
        value: '75%',
        label: 'Sales Increased'
      },
      {
        value: '98%',
        label: 'Clients Satisfaction'
      },
      {
        value: '2X',
        label: 'Conversion Rate'
      },
      {
        value: '80%',
        label: 'Better Search Ranking'
      }
    ]
  },
  'brand-registration': {
    title: 'Amazon Brand Registry Process',
    image: '/images/Amazon Brand Registry Process.jpg',
    subtitle: 'Secure Your Brand\'s Future with Expert Registration Support',
    description: 'At TrioPerspective, we understand the value of brand protection and visibility. Amazon Brand Registry helps safeguard your intellectual property and gives you enhanced control over your listings. Our team is here to guide you through every step of the Amazon Brand Registration process, ensuring that your brand stands out and thrives on Amazon.',
    overviewTitle: 'Brand Registration Service?',
    overview: 'In the ever-evolving Amazon marketplace, brand protection and recognition are paramount. With our Amazon Brand Registration help, we ensure that your brand gets the recognition it deserves, while also protecting it from unauthorized sellers and counterfeit products.',
    optimization: 'Our Process to Secure Your Brand',
    optimizationDescription: 'We know that each brand is unique, and we treat it as such. Our approach to Amazon Brand Registration is personalized and tailored to your business\'s needs. We help you navigate the entire process, from ensuring eligibility to completing the registration steps, so your brand can enjoy full benefits on Amazon.',
    features: [
      {
        title: 'Eligibility Check',
        description: 'We verify your brand\'s eligibility for Amazon Brand Registry and make sure you meet all necessary requirements.'
      },
      {
        title: 'Trademark Verification',
        description: 'We guide you through the trademark process to ensure your brand is legally protected before registration.'
      },
      {
        title: 'Brand Name & Logo Setup',
        description: 'Our team ensures your brand name and logo meet Amazon\'s specific criteria for an accurate registration.'
      },
      {
        title: 'Submit Your Application',
        description: 'We prepare and submit your Brand Registry application, ensuring all required documents and details are in place for quick approval.'
      }
    ],
    results: 'Protect Your Brand on Amazon',
    resultsDescription: 'We help you secure your brand\'s identity on Amazon, unlock special tools, and stand out from the competition.',
    benefits: [
      'Keep Your Brand Safe',
      'Use Exclusive Brand Tools',
      'Build Trust with Buyers',
      'Stay Ahead of Competitors'
    ],
    stat: [
      {
        value: '75%',
        label: 'Sales Increased'
      },
      {
        value: '98%',
        label: 'Clients Satisfaction'
      },
      {
        value: '2X',
        label: 'Conversion Rate'
      },
      {
        value: '80%',
        label: 'Better Search Ranking'
      }
    ]
  },
  'catalogue-management': {
    title: 'Amazon Catalogue Management',
    image: '/images/Amazon Catalogue Management.jpg',
    subtitle: 'Unlock the Power of a Well-Optimized Product Catalogue',
    description: 'At TrioPerspective, we know that a well-organized and optimized product catalogue is the foundation of a successful Amazon business. From product listing creation to inventory updates, our expert team ensures your catalogue stands out, drives visibility, and attracts potential customers. Let us handle your catalogue management, so you can focus on scaling your business.',
    overviewTitle: 'Catalogue Management Team?',
    overview: 'In the fast-paced Amazon marketplace, maintaining an organized, up-to-date, and high-quality catalogue is crucial for your success. Our catalogue management service is designed to boost your product visibility, ensure correct information, and streamline your listings for a seamless customer experience. We help you make your products more discoverable, engaging, and easy to purchase—ensuring every product in your catalog is ready to convert visitors into buyers.',
    optimization: 'Our Process to Optimize Your Catalogue',
    optimizationDescription: 'We understand that every product has its own set of unique requirements. That\'s why we tailor our catalogue management services to your specific needs. Here\'s how we approach optimizing your Amazon catalog for maximum performance:',
    features: [
      {
        title: 'Product Listing Optimization',
        description: 'We optimize each listing for Amazon\'s algorithm by ensuring high-quality images, keyword-rich titles, and compelling product descriptions to improve discoverability and click-through rates.'
      },
      {
        title: 'Inventory Management',
        description: 'We track your stock levels to ensure your listings are accurate and always reflect real-time inventory. We prevent stockouts and reduce the risk of overselling, maintaining smooth operations.'
      },
      {
        title: 'Categorization and Organization',
        description: 'Our team ensures that every product is placed in the right category with the correct attributes, improving search results and simplifying customer navigation.'
      },
      {
        title: 'Performance Tracking and Analysis',
        description: 'We closely monitor the performance of each product listing, providing data-driven insights to further refine your catalog for better results.'
      }
    ],
    results: 'Sell More with Smart Amazon Catalogue Management',
    resultsDescription: 'We keep your Amazon catalogue in top shape, making it easy for shoppers to find, love, and buy your products.',
    benefits: [
      'No Stock-Out Drama',
      'Improve Customer Experience',
      'Stay Ahead with Amazon Policies',
      'Build Brand Trust'
    ],
    stat: [
      {
        value: '75%',
        label: 'Sales Increased'
      },
      {
        value: '98%',
        label: 'Clients Satisfaction'
      },
      {
        value: '2X',
        label: 'Conversion Rate'
      },
      {
        value: '80%',
        label: 'Better Search Ranking'
      }
    ]
  },
  'analytics': {
    title: 'Amazon Graphic Services',
    image: '/images/graphic.jpg',
    subtitle: 'Transform Your Brand\'s Visual Appeal with Expert Graphics Design',
    description: 'At TrioPerspective, we believe that visuals are not just about looking good—they\'re about driving engagement and conversions. From eye-catching main images to detailed A+ Content, we design every element to perfectly represent your brand and product while optimizing for Amazon\'s platform. Let us transform your product listings into a visual storytelling masterpiece that captures attention and drives sales.',
    optimization: 'Maximize Your Sales with Stunning Amazon Graphics',
    optimizationDescription: 'Visual content is critical in creating a lasting impression on Amazon shoppers. We design high-quality Main Images, EBC Design and Store Design that capture attention, convey your product\'s value, and provide customers with clear, persuasive visual content. Our team\'s goal is to elevate your product\'s presence and drive conversions, helping your business reach its full potential on Amazon.',
    overviewTitle: 'Amazon Graphic Designs?',
    overview: 'In the highly competitive Amazon marketplace, your product\'s images and designs can make or break a sale. We take pride in creating impactful visuals that tell your brand\'s story and guide shoppers through the purchase journey. Whether it\'s your main image, A+ content, or a customized brand store, we focus on delivering visuals that resonate with your target audience and compel them to click "Buy Now."',
    features: [
      {
        title: 'Main Image Concepts',
        description: 'Your main image is the first thing customers see. We create clear, high-quality main images that highlight your product\'s key features. By following Amazon\'s strict image requirements and optimizing visuals, we ensure your product catches the shopper\'s eye and stands out in search results.'
      },
      {
        title: 'A+ Content',
        description: 'A+ Content allows you to showcase your product in a more detailed, visually appealing way. We design rich, multimedia-enhanced A+ content that educates potential customers about your product\'s benefits, features, and specifications, driving higher engagement and conversion rates. Our team ensures the design is aligned with your brand\'s personality and communicates its value effectively.'
      },
      {
        title: 'Premium A+ Content',
        description: 'Premium A+ Content offers additional multimedia elements to further enhance your product\'s presentation. We go beyond traditional A+ content by incorporating videos, comparison charts, and custom images to deliver an elevated, professional presentation of your product. With our expertise, we ensure your Premium A+ content drives maximum impact and provides a better shopping experience for your customers.'
      },
      {
        title: 'Brand Story',
        description: 'Your Brand Story helps convey your mission, values, and vision to potential customers. We craft a compelling, visually-driven narrative that tells the unique story behind your brand. Through thoughtful imagery and design, we ensure that your story connects with customers on an emotional level, enhancing trust and building loyalty.'
      },
      {
        title: 'Brand Store Design',
        description: 'An Amazon Brand Store serves as your brand\'s online showcase. We design clean, engaging, and customer-friendly brand stores that reflect your brand identity and highlight your product range. Whether you\'re looking to create a fully-customized storefront or need help organizing product categories, we offer seamless, visually captivating designs that help boost sales and increase brand recognition.'
      },
      {
        title: '3D Designs of Products',
        description: 'We offer realistic 3D designs of your products, adding a dynamic and engaging touch to your online presence. These designs help highlight the details of your products in a visually compelling way, making them stand out in Amazon search results and capture customer attention.'
      }
    ],
    results: 'Images That Convert Visitors into Buyers',
    resultsDescription: 'We create eye-catching images that grab buyers\' attention and make them interested. By mixing creativity with strategy, we design visuals that not only attract but also encourage purchases, making your product hard to resist.',
    benefits: [
      'Increase Click-Through Rates',
      'Boost Conversion potential',
      'Build Brand Trust',
      'Stand Out from The Market Competition'
    ],
    stat: [
      {
        value: '75%',
        label: 'Sales Increased'
      },
      {
        value: '98%',
        label: 'Clients Satisfaction'
      },
      {
        value: '2X',
        label: 'Conversion Rate'
      },
      {
        value: '80%',
        label: 'Better Search Ranking'
      }
    ]
  },
};

const SingleService = () => {
  const { serviceId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const service = services[serviceId];

  if (!service) {
    navigate('/services');
    return null;
  }

  return (
    <main className="bg-black min-h-screen">
      <SingleServiceModern service={service} />
      <Banner4 />
    </main>
  );
};

export default SingleService;
